/*
  Quick view: collapse long product descriptions — Premier Pool & Spa custom.
  Inside the quick-shop modal, if a description is taller than the limit it is
  clamped with a fade and a "Show full description" toggle, so the quantity,
  purchase options and Add to cart / Request a quote buttons stay in view.
  Styles: assets/site-polish.css (.qv-clamp, .qv-clamp__toggle)
*/
(function (w, d) {
  'use strict';
  var LIMIT = 240; // px of description shown before clamping

  function clamp(rte) {
    if (rte.dataset.qvClamp) return;
    if (!rte.offsetParent) return; // modal not visible yet, can't measure
    rte.dataset.qvClamp = 'done';
    if (rte.scrollHeight <= LIMIT + 60) return; // short enough, leave it alone

    rte.classList.add('qv-clamp');
    rte.style.maxHeight = LIMIT + 'px';

    var btn = d.createElement('button');
    btn.type = 'button';
    btn.className = 'qv-clamp__toggle';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span data-more>Show full description</span><span data-less>Show less</span>' +
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20" width="14" height="14"><path d="M4 7l6 6 6-6" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    btn.addEventListener('click', function () {
      var open = rte.classList.toggle('qv-clamp--open');
      rte.style.maxHeight = open ? rte.scrollHeight + 'px' : LIMIT + 'px';
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) rte.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    });
    rte.insertAdjacentElement('afterend', btn);
  }

  function scan() {
    var list = d.querySelectorAll('.modal--quick-shop [data-product-blocks] > .product-block > .rte');
    for (var i = 0; i < list.length; i++) clamp(list[i]);
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; scan(); }, 80);
  }

  function start() {
    scan();
    new MutationObserver(schedule).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
  }

  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', start); else start();
})(window, document);
